import I18n from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { usePreviewAsStudent } from "../Shared/usePreviewAsStudent";

export const CourseHelloBar = () => {
  const { isCoursePreview, onStopCoursePreview } = usePreviewAsStudent();

  if (!isCoursePreview) {
    return null;
  }

  return (
    <div
      className="bg-dark-primary-button grid-in-hellobar flex flex-col items-center justify-center space-x-1 px-2 py-3 md:flex-row"
      data-testid="course-hello-bar"
    >
      <Typography.LabelSm weight="medium" color="text-badge">
        {I18n.t("courses.preview_hellobar")}
      </Typography.LabelSm>
      <button type="submit" onClick={onStopCoursePreview} className="border-b">
        <Typography.LabelSm weight="medium" color="text-badge">
          {I18n.t("courses.return_to_dashboard")}
        </Typography.LabelSm>
      </button>
    </div>
  );
};
